import { apiWrapper, apiCancel } from '../../wrapper'

export const initial = 'user'
const baseUrl = process.env.REACT_APP_SERVICE_CORE_URL
const appCode = process.env.REACT_APP_SERVICE_CORE_APPCODE
const outputType = 'json'


export const userGetData = 'user/getData/'

export const AwardList = 'Kepegawaian/Penghargaan/list/'
export const AwardPeriodeList = 'Kepegawaian/Penghargaan/awardperiodelist/'
export const AwardTypeList = 'Kepegawaian/Penghargaan/awardtypelist/'
export const AwardSignatories = 'Kepegawaian/Penghargaan/signatories/'
export const AwardCreate = 'Kepegawaian/Penghargaan/create/'
export const AwardActive = 'Kepegawaian/Penghargaan/active/'
export const AwardInactive = 'Kepegawaian/Penghargaan/inactive/'
export const AwardExclude = 'Kepegawaian/Penghargaan/exclude/'
export const AwardDetail = 'Kepegawaian/Penghargaan/detail/'
export const AwardUpdate = 'Kepegawaian/Penghargaan/update/'
export const AwardApprove = 'Kepegawaian/Penghargaan/approve/'
export const AwardRevoke = 'Kepegawaian/Penghargaan/revoke/'
export const AwardReject = 'Kepegawaian/Penghargaan/reject/'
export const AwardReload = 'Kepegawaian/Penghargaan/reload/'

export const AwardEmployeeList = 'Kepegawaian/Penghargaan/employeeList/'

export const AwardPeriodList = 'Kepegawaian/PeriodePenghargaan/list/'
export const AwardPeriodoption = 'Kepegawaian/PeriodePenghargaan/option/'
export const AwardPeriodAwardList = 'Kepegawaian/PeriodePenghargaan/awardList/'
export const AwardPeriodCreate = 'Kepegawaian/PeriodePenghargaan/create/'
export const AwardPeriodInactive = 'Kepegawaian/PeriodePenghargaan/inactive/'
export const AwardPeriodDetail = 'Kepegawaian/PeriodePenghargaan/detail/'
export const AwardPeriodUpdate = 'Kepegawaian/PeriodePenghargaan/update/'
export const AwardPeriodApprove = 'Kepegawaian/PeriodePenghargaan/approve/'
export const AwardPeriodExport = 'Kepegawaian/PeriodePenghargaan/export/'
export const AwardPeriodPrediction = 'Kepegawaian/PeriodePenghargaan/prediksi/'


export const cancelToken = () => {
    return apiCancel()
}
export const apiRequest = async (method, route, data = { params: null, body: null, cancelToken: null }, needToken=true) => {
    if(needToken) {
        const thisTime = (Math.floor(Date.now()/1000))
        const expire = localStorage.getItem(initial + 'accessExpired')
        if(expire < thisTime) {
           await apiWrapper(baseUrl, initial, appCode, outputType, 'post', 'auth/getAccessToken/', data)
           .then(result => {
                localStorage.setItem(initial + 'accessToken', result.response.access_token)
                return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
            })
            .catch(result => {
                return Promise.reject('Tidak dapat mengambil accessToken');
            })
        } else {
            return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)        
        }
    }
    return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
}